import * as React from 'react';
export const addCircleFilledSvg = React.forwardRef(
  function addCircleFilledSvgInner(props, ref) {
    return /*#__PURE__*/ React.createElement(
      'svg',
      {
        ...props,
        ref: ref,
      },
      /*#__PURE__*/ React.createElement('path', {
        fillRule: 'evenodd',
        clipRule: 'evenodd',
        d: 'M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16Zm.75-12a.75.75 0 0 0-1.5 0v3.25H4a.75.75 0 0 0 0 1.5h3.25V12a.75.75 0 0 0 1.5 0V8.75H12a.75.75 0 0 0 0-1.5H8.75V4Z',
      }),
    );
  },
);
addCircleFilledSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var addCircleFilled = {
  category: 'icon',
  colorable: true,
  name: 'addCircleFilled',
  svg: addCircleFilledSvg,
};
